module.exports = __webpack_public_path__ + "img/video-player/wow@3x-304d2229b0e4e0393097a6fde1f79590.png";